<template>
  <div class="aroma-mine aroma-primary-page">
    <header class="aroma-page-header">
      <h1>我的</h1>
      <p v-if="profile.organizationName">{{ profile.organizationName }}</p>
    </header>

    <main class="aroma-mine__content">
      <div v-if="loading" class="aroma-page-state">
        <van-loading size="28px">加载中...</van-loading>
      </div>
      <van-empty v-else-if="errorMessage" :description="errorMessage" />
      <template v-else>
        <section class="aroma-profile-summary">
          <img src="@img/mine-avatar.png" alt="用户头像" />
          <div>
            <h2>{{ displayValue(profile.realName) }}</h2>
            <p>{{ displayValue(profile.phoneNumber) }}</p>
          </div>
        </section>

        <section class="aroma-info-list" aria-label="个人信息">
          <div v-for="item in infoRows" :key="item.label" class="aroma-info-list__row">
            <span>{{ item.label }}</span>
            <strong>{{ item.value }}</strong>
          </div>
        </section>

        <van-button class="aroma-mine__logout" block @click="confirmLogout">退出登录</van-button>
      </template>
    </main>

    <aroma-tabbar />
  </div>
</template>

<script>
import dayjs from 'dayjs'
import API from '@/api'
import AromaTabbar from '@/components/aroma-report/AromaTabbar.vue'
import { clearSniSession, getSniSession, saveSniSession } from '@/utils/sni-session'

export default {
  name: 'AromaMine',

  components: {
    AromaTabbar
  },

  data () {
    return {
      loading: false,
      profile: {},
      errorMessage: ''
    }
  },

  computed: {
    sn () {
      return this.$route.query.sn || ''
    },

    session () {
      return getSniSession(this.sn)
    },

    infoRows () {
      return [
        { label: '手机号', value: this.displayValue(this.profile.phoneNumber) },
        { label: '姓名', value: this.displayValue(this.profile.realName) },
        { label: '性别', value: this.profile.sex === '0' ? '男' : this.profile.sex === '1' ? '女' : '--' },
        { label: '生日', value: this.profile.birthday ? dayjs(this.profile.birthday).format('YYYY-MM-DD') : '--' },
        { label: '身高', value: this.profile.height ? `${this.profile.height} cm` : '--' },
        { label: '体重', value: this.profile.weight ? `${this.profile.weight} kg` : '--' }
      ]
    }
  },

  mounted () {
    this.loadProfile()
  },

  methods: {
    displayValue (value) {
      return value || '--'
    },

    async loadProfile () {
      this.loading = true
      this.errorMessage = ''
      try {
        this.profile = await API.sniCurrent(this.session.token)
        saveSniSession(this.sn, {
          ...this.session,
          profileCompleted: this.profile.profileCompleted
        })
      } catch (error) {
        clearSniSession(this.sn)
        this.$router.replace({
          name: 'AromaReportLogin',
          query: { sn: this.sn, redirect: this.$route.fullPath }
        })
      } finally {
        this.loading = false
      }
    },

    async confirmLogout () {
      try {
        await this.$dialog.confirm({
          title: '退出登录',
          message: '确认退出当前账号吗？',
          confirmButtonText: '退出',
          cancelButtonText: '取消'
        })
        clearSniSession(this.sn)
        this.$router.replace({ name: 'AromaReportLogin', query: { sn: this.sn } })
      } catch (error) {
        // Cancel keeps the current session.
      }
    }
  }
}
</script>

<style scoped lang="scss">
@import '@/assets/css/aroma-commerce.scss';

.aroma-mine {
  &__content {
    padding: 0 12px;
  }

  &__logout {
    height: 48px;
    margin-top: 20px;
    color: #ff4c45;
    font-size: 16px;
    background: #fff;
    border: 0;
    border-radius: 4px;
  }
}

.aroma-profile-summary {
  display: flex;
  align-items: center;
  padding: 20px 18px;
  background: #fff;
  border-radius: 6px;

  img {
    width: 58px;
    height: 58px;
    object-fit: cover;
  }

  div {
    min-width: 0;
    margin-left: 14px;
  }

  h2 {
    color: #1f2329;
    font-size: 18px;
    font-weight: 500;
    line-height: 26px;
  }

  p {
    margin-top: 3px;
    color: #8a8f98;
    font-size: 14px;
    line-height: 22px;
  }
}

.aroma-info-list {
  margin-top: 12px;
  overflow: hidden;
  background: #fff;
  border-radius: 6px;

  &__row {
    display: flex;
    min-height: 50px;
    align-items: center;
    justify-content: space-between;
    gap: 18px;
    padding: 0 16px;
    border-bottom: 1px solid #f0f1f3;

    &:last-child {
      border-bottom: 0;
    }

    span,
    strong {
      font-size: 15px;
      line-height: 22px;
    }

    span {
      color: #646a73;
    }

    strong {
      overflow-wrap: anywhere;
      color: #1f2329;
      font-weight: 400;
      text-align: right;
    }
  }
}
</style>
